import firebase from 'firebase/app';
import 'firebase/auth';
import React from 'react';
import { useMediaQuery } from 'react-responsive';

import config from './config';

let dateFormat = require("dateformat");

//TODO: Add request security, maybe pat can help with this.
export const getCompanyRegionalityInfo = (companyName) => {
    return new Promise((resolve, reject) => {
        fetch(config.insights.getPeopleInsightsUrl(companyName))
        .then(response => response.json())
        .then(data => {
            return resolve(data);
        })
        .catch(reject);
    });
}

export const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
    return isTablet ? children : null;
}

export const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 })
    return isMobile ? children : null;
}

export const NotMobile = ({ children }) => {
    const isMobile = useMediaQuery({ minWidth: 768 })
    return isMobile ? children : null;    
}

export const getRemotePolicyText = (policy) => {
    let res = "";

    if (!policy) return "Not Defined";

    switch(policy) {
        case "fully-distributed":
            res = "Fully Distributed";
            break;
        case "remote-first":
            res = "Remote-First";
            break;
        case "remote-friendly":
            res = "Remote-Friendly";
            break;
        case "temp-remote":
            res = "Temporarily Remote";
            break;
        default:
            res = "Not Defined";
    }

    return res;
}

export const getRemoteSinceText = (remoteSince) => {
    if (!remoteSince || !remoteSince.toDate) {
        return "-";
      }
      if (remoteSince.toDate().getTime() === new Date("1991-08-06").getTime()) {
        return "Always";
      } else if (remoteSince) {
        return dateFormat(remoteSince.toDate(), "mmm d, yyyy");
      } else {
        return "-";
      }    
}

export const getRemoteUntilText = (isPermanent, remoteUntil) => {
    if (isPermanent) {
        return "-";
      } else {
        return dateFormat(remoteUntil.toDate(), "mmm d, yyyy");
      }
}

export const getRemoteDateRangeText = (row) => {
    let remoteText = "";
    if (row.remoteSince === "Always") {
      remoteText = "(Always)";
    } else {
      remoteText = `(${
        row.remoteSince === "-" ? "" : `${row.remoteSince} `
      }${
        row.remoteUntil === "-" ? "onwards" : `until ${row.remoteUntil}`
      })`;
    }

    return remoteText;
}

export const getRemotePolicyDateRange = (data) => {
    const obj = {};
    const { remoteSince, remoteUntil, perm } = data;

    obj.remoteSince = getRemoteSinceText(remoteSince);

    if (obj.remoteSince === "Always") {
        obj.remoteUntil = "-";
    } else {
        obj.remoteUntil = getRemoteUntilText(perm, remoteUntil);
    }

    return getRemoteDateRangeText(obj);
}

export const getCompanyScore = (company) => {
    if (company && company.reviews && company.reviews.details && company.reviews.details.length) {
        let score = 0;

        company.reviews.details.forEach(review => {
            score += review.rating;
        })

        return score / company.reviews.details.length;
    }

    return -1;
}

export const createTableRowFromAggregateCompanyData = (companyData) => {
    console.log('company data: ', companyData);
    
    let {
        companyName: name,
        remoteSince,
        remoteUntil,
        source,
        perm: isPermanent,
        remotePolicy,
        policyDuration,
        companyInfo,
        jobsLink,
    } = companyData;    

    const getJobsLink = (source) => {
        let url = "";
        try {
          url = new URL(source);
        } catch (e) {
          return <span style={{ textTransform: "capitalize" }}>Not Available</span>;
        }
    
        // Prettify
        if (url.hostname.substring(0, 4) === "www.") {
          url.hostname = url.hostname.substring(4);
        }
    
        return (
          <a
            href={source}
            target="_blank"
            className={this.props.classes.sourceLink}
          >
            {url.hostname.includes("jobs") || url.hostname.includes("careers")
              ? `${url.hostname}`
              : `${url.hostname}/jobs`}
          </a>
        );
      }      

    const getSource = (source) => {
        if (source.toLowerCase() === "internal email") return "Internal Email";
    
        let url = "";
        try {
          url = new URL(source);
        } catch (e) {
          return <span style={{ textTransform: "capitalize" }}>source</span>;
        }
    
        if (url.hostname.substring(0, 4) === "www.") {
          url.hostname = url.hostname.substring(4);
        }
   
        return (
          <a
            href={source}
            target="_blank"
            className={this.props.classes.sourceLink}
          >
            {url.hostname}
          </a>
        );
      }     

    const getStatus = (isPermanent, remoteUntil, indefinite) => {
        if (isPermanent) {
          return <b>Permanent</b>;
        } else if (indefinite) {
          return "Indefinite";
        } else if (
          !isPermanent &&
          remoteUntil.toDate().getTime() > new Date().getTime()
        ) {
          return "Current";
        } else {
          return "No Longer Remote";
        }
      }  

    const getRemoteSinceResult = (remoteSince) => {
        if (!remoteSince || !remoteSince.toDate) {
          return "-";
        }
        if (remoteSince.toDate().getTime() === new Date("1991-08-06").getTime()) {
          return "Always";
        } else if (remoteSince) {
          return dateFormat(remoteSince.toDate(), "mmm d, yyyy");
        } else {
          return "-";
        }
      }   
      
    const getRemoteUntilResult = (isPermanent, remoteUntil) => {
        if (isPermanent) {
          return "-";
        } else {
          return dateFormat(remoteUntil.toDate(), "mmm d, yyyy");
        }
      }      


    if (remotePolicy) {
        if (remotePolicy === "fully-distributed") {
          remotePolicy = "Fully Distributed";
        } else if (remotePolicy === "remote-first") {
          remotePolicy = "Remote-First";
        } else if (remotePolicy === "remote-friendly") {
          remotePolicy = "Remote-Friendly";
        } else {
          remotePolicy = "Temporarily Remote";
        }
      } else {
        remotePolicy = "Not Defined";
      }  
      

      let statusRes = getStatus(isPermanent, remoteUntil);
      let remoteSinceRes = getRemoteSinceResult(remoteSince);
      let remoteUntilRes;

      if (remoteSinceRes === "Always") {
        remoteUntilRes = "-";
        statusRes = getStatus(true, null);
      } else {
        remoteUntilRes = getRemoteUntilResult(isPermanent, remoteUntil);
      }

      if (policyDuration && policyDuration === "indefinite") {
        remoteUntilRes = "Indefinite";
      }

      return {
        name,
        status: remotePolicy,
        remoteSince: remoteSinceRes,
        remoteUntil: remoteUntilRes,
        source: getSource(source),
        numEmployees: companyInfo?.companyData?.employees || "",
        jobsLink: getJobsLink(jobsLink || ""),
        hq: companyInfo?.companyData?.HQ || "",
        logo: companyInfo?.companyData?.icon?.logo || "",
      };      

}